module.exports = __webpack_public_path__ + "static/img/bonus_4.665b851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/bonus_4.png
// module id = Gn/2
// module chunks = 0